import { DataTable } from 'primereact/datatable'
import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import './dataTableComp.scss'
import { Group, Table } from '@mantine/core'
import { useResizeObserver, useViewportSize } from '@mantine/hooks'
import { themeCfg } from '../../../theme/theme.ts'
import PaginatorComp from '../paginator/PaginatorComp'
import AppLegacyPaginator from '../../../component/data/AppLegacyPaginator.tsx'

const DataTableComp = ({
  loading = false,
  disableAutoheight = false,
  autoheightOffset = 0,
  pagerOptions,
  tableOptions,
  autoColumnKey = false /* Avoid: Warning: Each child in a list should have a unique "key" prop. */,
  columns,
}) => {
  const { formatMessage: msg } = useIntl()

  const resize = () => {
    const containerWidth =
      document.querySelector('.app-main-viewport')?.clientWidth || 0
    const containerHeight =
      document.querySelector('.app-main-viewport')?.clientHeight || 0
    const datatableHeaderHeight = document.querySelector('.p-datatable-header')
      ? document.querySelector('.p-datatable-header').offsetHeight
      : 0
    // const datatableHeaderHeight = 0
    const datatableFooterHeight = document.querySelector('.p-datatable-footer')
      ? document.querySelector('.p-datatable-footer').offsetHeight
      : 0
    const datatableHeight =
      document.querySelector('.p-datatable-wrapper')?.clientHeight || 0
    /* Margen de seguridad, borders, etc. */
    /* Este parámetro depende de la configuración de layout y de algunos márgenes */
    /* No se puede hacer más con el componente DataTable de PrimeReact */
    // const offset = 23
    const offset = 0

    document
      .querySelectorAll(':not(.disable-autoheight) > .p-datatable-wrapper')
      ?.forEach((componentData) => {
        const height =
          containerHeight -
          (datatableHeaderHeight + datatableFooterHeight + offset)

        const threshold = 12

        if (!disableAutoheight) {
          if (Math.abs(height - datatableHeight) > threshold) {
            componentData.style['min-height'] = height + 'px'
            componentData.style['max-height'] = height + 'px'
            componentData.style.height = height + 'px'
          }

          // componentData.style.width = "100%"

          // componentData.style["min-width"] = (containerWidth) + "px"
          // componentData.style["max-width"] = (containerWidth) + "px"
          // componentData.style.width = (containerWidth) + "px"

          // console.log(containerWidth, containerHeight, datatableHeight)
        }
      })
  }

  const handleResize = () => {
    console.log('handleResize', disableAutoheight)

    if (!disableAutoheight) {
      resize()

      setTimeout(() => {
        resize()
      }, 2000)
    }
  }

  useEffect(() => {
    if (!disableAutoheight) handleResize()
    ;['load', 'resize'].forEach((e) => {
      window.addEventListener(e, handleResize)
    })
    return () => {
      ;['load', 'resize'].forEach((e) => {
        window.removeEventListener(e, handleResize)
      })
    }
  }, [])

  // if (!disableAutoheight) handleResize()

  return (
    <DataTable
      {...tableOptions}
      className={`${tableOptions?.className || ''} ${disableAutoheight ? 'disable-autoheight' : ''}`}
      style={{ minWidth: '100%', width: '100%' }}
      loading={loading}
      // onLoad={handleResize}
      header={
        tableOptions?.header ? (
          <Group h={50} p={themeCfg?.default?.padding}>
            {tableOptions?.header}
          </Group>
        ) : null
      }
      footer={pagerOptions ? <AppLegacyPaginator {...pagerOptions} /> : null}
      scrollable={!disableAutoheight}
      scrollHeight="auto"
      data-disable-autoheight={disableAutoheight}
      data-autoheight-offset={autoheightOffset}
      emptyMessage={msg({ id: 'placeholder.not.data' })}
    >
      {autoColumnKey
        ? // This patch avoid: Warning: Each child in a list should have a unique "key" prop.
          columns.map((column, idx) => ({
            ...column,
            key: column.key || column._id || column.field || 'key-'.concat(idx),
          }))
        : columns}
    </DataTable>
  )
}

export default DataTableComp
